import { Container, Loading } from "@/components/atoms";
import { GeneralFooter, GeneralHeader, SignUpSteps, useSignUpContext } from "@/components/organisms";
import { useOperator } from "@/hooks";
import { useEffect, useState } from "react";
import { userTypes } from "@/components/organisms/SignUp/fixtures";

export const OperatorSignUp = () => {
  const { singleTenant } = useOperator();
  const { setStep, setUserTypeData } = useSignUpContext();
  const [isLoading, setIsLoading] = useState(true);
  const [signUpEnabled, setSignUpEnabled] = useState(false);
  
  useEffect(() => {
    setUserTypeData(userTypes.operator);
    setStep("signup");
    setIsLoading(false);
    setSignUpEnabled(!singleTenant);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading || !signUpEnabled) return <Loading />;

  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action="login" />
        <Container className="relative flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8 md:py-[100px]">
          <SignUpSteps />
        </Container>
        <GeneralFooter />
      </div>
    </div>
  );
};
